import React from 'react';
import PropTypes from 'prop-types';
import './Avatar.css';

const Avatar = ({ image }) => {
  return (
    <div className="avatar">
      <img src={image} alt="User" />
    </div>
  );
};

Avatar.propTypes = {
  image: PropTypes.string,
};

Avatar.defaultProps = {
  image:
    'https://i0.wp.com/www.repol.copl.ulaval.ca/wp-content/uploads/2019/01/default-user-icon.jpg',
};

export default Avatar;
